import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION_TYPE_OPTION_IDS, IMAGE_TEXT_DROPDOWN_OPTION_IDS } from 'commons/constants';
import { customItem, readyToShipItem, decideLaterItem } from 'components/consumer/PDP/PDPShopTabsBar/itemContent';
import getEnvValue from 'commons/getEnvValue';
import useScreen from 'hooks/useScreen';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSelectionAlert from './PDPSelectionAlert/PDPSelectionAlert';
import PDPSelectUpholsteryInner from '../PDPSelectUpholstery';
import PDPImageSelector from '../PDPImageSelector';
import PDPImageAndTextSelector from '../PDPImageAndTextSelector';
import PDPTextDropdownOptionGroup from '../PDPTextDropdownOptionGroup';
import PDPImageTextDropdownOption from '../PDPImageTextDropdownOption';
import PDPUpsellProduct from '../PDPUpSellProduct';
import PDPExtraOptionSelector from '../PDPExtraOptionSelector';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';
import PDPSelectUpholsteryPlaceholder from '../PDPSelectUpholstery/PDPSelectUpholsteryPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';
const getTabContentId = selectedTab => {
  if (selectedTab === customItem.id) {
    return customItem.contentId;
  }
  if (selectedTab === readyToShipItem.id) {
    return readyToShipItem.contentId;
  }
  if (decideLaterItem.id) {
    return decideLaterItem.contentId;
  }
  return '';
};
const IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED = getEnvValue('NEXT_PUBLIC_IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED') === 'true';
const PDPChooseYourOptionsUIInner = t0 => {
  const $ = _c(46);
  const {
    pdpIsModularBYOProduct,
    isDecideLaterTab,
    isEditOrder: t1,
    isFFG: t2,
    isRTSTab: t3,
    loading: t4,
    mode: t5,
    options: t6,
    onMoreMaterialsClick,
    productId: t7,
    selectionValidity: t8,
    slug: t9,
    upholsteryOptionId,
    optionSelector: t10,
    setMarxentSelectedFabric,
    isLayoutRevamp: t11
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const isFFG = t2 === undefined ? true : t2;
  const isRTSTab = t3 === undefined ? false : t3;
  const loading = t4 === undefined ? false : t4;
  const mode = t5 === undefined ? "pdp" : t5;
  let t12;
  if ($[0] !== t6) {
    t12 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t12;
  } else {
    t12 = $[1];
  }
  const options = t12;
  const productId = t7 === undefined ? null : t7;
  const selectionValidity = t8 === undefined ? "" : t8;
  const slug = t9 === undefined ? null : t9;
  const optionSelector = t10 === undefined ? "" : t10;
  const isLayoutRevamp = t11 === undefined ? false : t11;
  const {
    isMobile
  } = useScreen();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  if (loading) {
    let t13;
    if ($[2] !== pdpSelectedCustomizerTab) {
      t13 = getTabContentId(pdpSelectedCustomizerTab);
      $[2] = pdpSelectedCustomizerTab;
      $[3] = t13;
    } else {
      t13 = $[3];
    }
    const t14 = mode === "pdp";
    let t15;
    if ($[4] !== t14) {
      t15 = classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": t14
      });
      $[4] = t14;
      $[5] = t15;
    } else {
      t15 = $[5];
    }
    let t16;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <PDPSelectUpholsteryPlaceholder />;
      $[6] = t16;
    } else {
      t16 = $[6];
    }
    let t17;
    if ($[7] !== t15) {
      t17 = <div className={t15}>{t16}</div>;
      $[7] = t15;
      $[8] = t17;
    } else {
      t17 = $[8];
    }
    let t18;
    if ($[9] !== t13 || $[10] !== t17) {
      t18 = <div className="flex w-full flex-col relative z-[3]" id={t13}>{t17}</div>;
      $[9] = t13;
      $[10] = t17;
      $[11] = t18;
    } else {
      t18 = $[11];
    }
    return t18;
  }
  let t13;
  if ($[12] !== loading || $[13] !== options || $[14] !== upholsteryOptionId) {
    t13 = !loading && upholsteryOptionId && options?.length ? options.find(opt => opt.id === upholsteryOptionId) : null;
    $[12] = loading;
    $[13] = options;
    $[14] = upholsteryOptionId;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const upholsteryOptionValue = t13;
  const t14 = optionSelector || "";
  let t15;
  if ($[16] !== t14) {
    t15 = t14.toLowerCase();
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const isUpholsterySelectorDropdownMode = t15 === "dropdown";
  let t16;
  if ($[18] !== pdpSelectedCustomizerTab) {
    t16 = getTabContentId(pdpSelectedCustomizerTab);
    $[18] = pdpSelectedCustomizerTab;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== isDecideLaterTab || $[21] !== isEditOrder || $[22] !== isFFG || $[23] !== isLayoutRevamp || $[24] !== isMobile || $[25] !== isUpholsterySelectorDropdownMode || $[26] !== loading || $[27] !== mode || $[28] !== onMoreMaterialsClick || $[29] !== optionSelector || $[30] !== options || $[31] !== pdpIsModularBYOProduct || $[32] !== productId || $[33] !== setMarxentSelectedFabric || $[34] !== slug || $[35] !== upholsteryOptionId || $[36] !== upholsteryOptionValue) {
    t17 = !loading && options?.length ? <>{isUpholsterySelectorDropdownMode && <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": mode === "quickview",
        "!z-[999]": mode !== "pdp"
      })} key="upholstery-selector-dropdown"><PDPTextDropdownOptionGroup optionId={upholsteryOptionValue?.id} isEditOrder={isEditOrder} slug={slug} /></div>}{isDecideLaterTab && !isUpholsterySelectorDropdownMode ? !isMobile && <PDPSelectUpholsteryDecideLater /> : upholsteryOptionValue && !isUpholsterySelectorDropdownMode ? <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", "PDPChooseYourOptionsUI__section--select-upholstery-wrapper", {
        "mt-0 mx-0 mb-4": mode === "quickview"
      })} key={upholsteryOptionValue.id} data-xc="MaterialThumbnailGroup"><PDPSelectUpholsteryInner isEditOrder={isEditOrder} mode={mode} optionId={upholsteryOptionValue.id} onMoreMaterialsClick={onMoreMaterialsClick} productId={productId} slug={slug} setMarxentSelectedFabric={setMarxentSelectedFabric} isLayoutRevamp={isLayoutRevamp} /></div> : <div className="PDPChooseYourOptionsUI__section--select-upholstery-wrapper-filler" />}<div className="PDPChooseYourOptionsUI__option-sections-wrapper">{options.map(option => {
          if (isFFG && option.id === 19 || option.id === upholsteryOptionId || pdpIsModularBYOProduct && ORIENTATION_TYPE_OPTION_IDS.includes(option.id) || (option.id !== 17 || option.id !== 18) && isEditOrder) {
            return null;
          }
          if (IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED && IMAGE_TEXT_DROPDOWN_OPTION_IDS.includes(option.id)) {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPImageTextDropdownOption optionId={option.id} /></div>;
          }
          if ((optionSelector || "").toLowerCase() === "dropdown") {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
          }
          switch (option.optionDisplayType) {
            case "ImageSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageSelector isEditOrder={isEditOrder} optionId={option.id} /></div>;
              }
            case "TextSelector":
            case "ImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} imageOrTextVariant={option.optionDisplayType === "TextSelector" ? "textOnly" : "regular"} mode={mode} optionId={option.id} productId={productId} variant="regular" /></div>;
              }
            case "PDPFullWidthImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} optionId={option.id} productId={productId} variant="fullWidth" /></div>;
              }
            case "TextDropdownSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview",
                  "!z-[999]": mode !== "pdp"
                })} key={option.id}><PDPTextDropdownOptionGroup key={`${option.id}--PDPTextDropdownOptionGroup`} optionId={option.id} /></div>;
              }
            case "UpsellSelector":
              {
                return <PDPUpsellProduct productId={productId} slug={slug} />;
              }
            case "ExtraOptionSelector":
              {
                return <PDPExtraOptionSelector key={`${option.id}--PDPExtraOptionSelector`} />;
              }
            default:
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview"
                })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
              }
          }
        })}</div></> : <><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /></>;
    $[20] = isDecideLaterTab;
    $[21] = isEditOrder;
    $[22] = isFFG;
    $[23] = isLayoutRevamp;
    $[24] = isMobile;
    $[25] = isUpholsterySelectorDropdownMode;
    $[26] = loading;
    $[27] = mode;
    $[28] = onMoreMaterialsClick;
    $[29] = optionSelector;
    $[30] = options;
    $[31] = pdpIsModularBYOProduct;
    $[32] = productId;
    $[33] = setMarxentSelectedFabric;
    $[34] = slug;
    $[35] = upholsteryOptionId;
    $[36] = upholsteryOptionValue;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== isRTSTab || $[39] !== loading || $[40] !== selectionValidity) {
    t18 = !loading && isRTSTab && selectionValidity ? <PDPSelectionAlert selectionValidity={selectionValidity} /> : <div className="PDPChooseYourOptionsUI__PDPSelectionAlert-filler" />;
    $[38] = isRTSTab;
    $[39] = loading;
    $[40] = selectionValidity;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t16 || $[43] !== t17 || $[44] !== t18) {
    t19 = <div className="flex w-full flex-col relative z-[3]" id={t16}>{t17}{t18}</div>;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
PDPChooseYourOptionsUIInner.propTypes = {
  isDecideLaterTab: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isFFG: PropTypes.bool,
  isRTSTab: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  optionSelector: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  productId: PropTypes.number,
  selectionValidity: PropTypes.string,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
  upholsteryOptionId: PropTypes.number,
  isLayoutRevamp: PropTypes.bool
};
const PDPChooseYourOptionsUI = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPChooseYourOptionsPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPChooseYourOptionsUIInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPChooseYourOptionsUI;